import { useTracks, VideoTrack } from '@livekit/components-react';
import { Track } from 'livekit-client';

import s from './floating-remote-video.module.scss';

/**
 * Плавающее окно с видео собеседника для мобильной версии:
 * остаётся видимым поверх шторки материалов (позиционируется
 * внутри колонки шторки). Аудио не дублирует — звук рендерит RoomAudioRenderer.
 */
export const FloatingRemoteVideo = () => {
	const tracks = useTracks([{ source: Track.Source.Camera }]);
	const remoteCamera = tracks.find(
		(t) => !t.participant.isLocal && t.publication && !t.publication.isMuted
	);

	if (!remoteCamera) {
		return null;
	}

	return (
		<div className={s.floatingVideo}>
			<VideoTrack trackRef={remoteCamera} />
		</div>
	);
};
